module.exports = __webpack_public_path__ + "img/login.818e9af8.png";